import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { useGetOne, useRecordContext, useTranslate } from 'react-admin';

import {
  GetB2bCompaniesIdEndpoint,
  GetB2bDashboardAffiliatesResponse,
} from '@Common/types/bo/b2b/companies';

import { mockAffiliates } from '@sh4res/bo-common/components/B2bCompanyDashboard/mock_data';
import { B2bCompanyDashboardProps } from '@sh4res/bo-common/components/B2bCompanyDashboard/utils';

export const AffiliatesSection = ({ useMock, resource }: B2bCompanyDashboardProps) => {
  const translate = useTranslate();
  const record = useRecordContext<GetB2bCompaniesIdEndpoint['Client']['ResponseBody']>();

  const { data: realData } = useGetOne<GetB2bDashboardAffiliatesResponse>(
    `${resource}/dashboard/affiliates`,
    { id: record?.id as number },
    { enabled: !!record },
  );

  const data = useMock ? mockAffiliates.data : realData?.data;

  if (!record || !data) {
    return null;
  }

  return (
    <Card sx={{ margin: '2px 2px 15px 2px', borderRadius: '8px' }}>
      <CardContent sx={{ padding: 0, paddingBottom: '0px !important' }}>
        <Box
          sx={{
            padding: '20px 20px 15px 20px',
          }}>
          <Typography variant="h3" sx={{ fontWeight: 600, fontSize: '1rem' }}>
            {translate(`resources.${resource}.dashboard.titles.affiliates`)}
          </Typography>
        </Box>
        <Divider />

        {/* Made an arbitrage */}
        <Box sx={{ display: 'flex', alignItems: 'center', px: '20px', py: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ width: '34%' }}>
            {translate(`resources.${resource}.dashboard.affiliates.made_arbitrage`)}
          </Typography>
          <Typography variant="body2" sx={{ width: '64%', textAlign: 'left', fontWeight: 500 }}>
            {data.affiliate_arbitrages}
          </Typography>
        </Box>
        <Divider />

        {/* Made a voluntary deposit */}
        <Box sx={{ display: 'flex', alignItems: 'center', px: '20px', py: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ width: '34%' }}>
            {translate(`resources.${resource}.dashboard.affiliates.made_voluntary_deposit`)}
          </Typography>
          <Typography variant="body2" sx={{ width: '64%', textAlign: 'left', fontWeight: 500 }}>
            {data.affiliate_volontary_deposits}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
